import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';

import Form from '../../components/NumberRegister/Form';

import { getQuery } from '../../../pages/Paspor/function';
import {
  postNumberRegisterDocLegal,
  getDocLegalServiceList,
  resetNumberRegisterDoc
} from '../action';
import { getServiceTitle, docLegalType } from '../functions';

const FormPassport = ({
  history,
  i18n,
  postNumberRegisterDocLegal,
  docLegalRegis,
  docLegalService,
  getDocLegalServiceList,
  resetNumberRegisterDoc
}) => {
  const { data, error, status } = docLegalRegis;
  const { serviceId, type } = getQuery(history);
  const keyTitle = getServiceTitle(get(docLegalService, ['data']), serviceId);
  const title =
    keyTitle && docLegalType[keyTitle] && i18n(`${docLegalType[keyTitle].label}`);
  let errorSaveMessage = '';

  if (status === 'rejected') {
    const message = get(error, ['response', 'data', 'error', 'message']);
    const keyDetail = get(error, ['response', 'data', 'error', 'detail', 0, 'key']);
    const messageDetail = get(error, [
      'response',
      'data',
      'error',
      'detail',
      0,
      'message'
    ]);
    errorSaveMessage = `${message}. ${keyDetail}: ${messageDetail}.`;
  }

  const handleSubmit = (params) => {
    postNumberRegisterDocLegal({
      ...params,
      legalization_service: serviceId
    });
  };

  useEffect(() => {
    if (status === 'resolve') {
      const { unique_number } = data || {};
      history.push(
        `/doc-legalization/registration/number-detail?uniqueId=${unique_number}&type=${type}`
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  useEffect(() => {
    getDocLegalServiceList();
    return () => {
      resetNumberRegisterDoc();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Form
      i18n={i18n}
      submit={handleSubmit}
      service_title={title}
      loadingStatus={status}
      errorSaveMessage={errorSaveMessage}
    />
  );
};

FormPassport.propTypes = {
  history: PropTypes.object,
  i18n: PropTypes.func,
  docLegalRegis: PropTypes.object,
  postNumberRegisterDocLegal: PropTypes.func,
  docLegalService: PropTypes.object,
  getDocLegalServiceList: PropTypes.func,
  resetNumberRegisterDoc: PropTypes.func
};

const mapStateToProps = (state) => ({
  docLegalRegis: {
    status: state.numberRegisterDocLegalReducer.status,
    error: state.numberRegisterDocLegalReducer.error,
    data: state.numberRegisterDocLegalReducer.data
  },
  docLegalService: {
    status: state.docLegalServiceReducer.status,
    error: state.docLegalServiceReducer.error,
    data: state.docLegalServiceReducer.data
  }
});

export default compose(
  connect(mapStateToProps, {
    postNumberRegisterDocLegal,
    getDocLegalServiceList,
    resetNumberRegisterDoc
  }),
  withRouter
)(FormPassport);
